module.exports = __webpack_public_path__ + "static/media/kg.1cfa1c79.svg";